var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"application"},[_c('AppHiddenFields',{attrs:{"variation":_vm.variation}}),_c('AppHeader',{attrs:{"invert-phone":""}}),_c('div',{staticClass:"application__content"},[_c('StepHandler',{ref:"StepHandler"})],1),_c('AppFooter'),_c('AppCookieManager')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }